import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import PersonalPropertyApi from "../../../api/PersonalProperty";
import ExportToNewListingModal from "./ExportToNewListingModal";
import ExportToExistingListingModal from "./ExportToExistingListingModal";

const propTypes = {
    isActive: PropTypes.bool.isRequired
};

class ChannelManagerAirbnb extends Component {
    constructor(props) {
        super(props);

        this.state = {
            exports: [],
            addAirbnbExportModalOpen: false,
            addAirbnbExportExistingModalOpen: false
        };

        this.load = this.load.bind(this)
        this.getLineForExport = this.getLineForExport.bind(this)
        this.handleChange = this.handleChange.bind(this)
    }

    load() {
        PersonalPropertyApi.getAirbnbExports(this.props.propertyId).then(({data}) => {
            this.setState({exports: data})
        })
    }

    componentDidMount() {
        this.load();
    }

    handleChange(event, exportId) {
        const {name, value} = event.target;

        if (name === 'synchronizationCategory') {
            PersonalPropertyApi.updateAirbnbExport(this.props.propertyId, exportId, value)
                .then(() => {
                    this.load();
                })
        }
    }

    getLineForExport(airbnbExport) {
        return <div className="grid grid-width-1-3">
            <div>
                <label>
                    <span className="info">
                        <i className="fa fa-question-circle"/>
                        <span>
                           hint?
                        </span>
                    </span>
                    Airbnb UserId:
                    <input
                        type="text"
                        placeholder="-"
                        value={airbnbExport.userId}
                        disabled
                    />
                </label>
            </div>
            <div>
                <label>
                    <span className="info">
                        <i className="fa fa-question-circle"/>
                        <span>
                            hint?
                        </span>
                    </span>
                    Airbnb Listing Id:
                    <input
                        type="text"
                        placeholder="-"
                        value={airbnbExport.listingId}
                        disabled
                    />
                </label>
            </div>
            <div>
                <label>
                    <span className="info">
                        <i className="fa fa-question-circle"/>
                        <span>
                            hint?
                        </span>
                    </span>
                    Enabled:
                    <select
                        value={airbnbExport.synchronizationCategory}
                        onChange={e => this.handleChange(e, airbnbExport.id)}
                        name='synchronizationCategory'
                    >
                        <option key='EVERYTHING' value='EVERYTHING'>Sync FULL</option>
                        <option key='LIMITED' value='LIMITED'>Sync Calendars And Rated only</option>
                        <option key='DISCONNECTED' value='DISCONNECTED'>Sync Disable</option>
                    </select>
                </label>
            </div>
        </div>
    }

    render() {
        const i18n = this.props.i18n;
        const exports = this.state.exports

        return (
            <div className={
                this.props.isActive ? 'clearfix tab_content animated show active' : 'clearfix tab_content animated show'
            }>
                <div className="heading">
                    <h3>
                        Channel Manager AirBnb
                    </h3>
                </div>

                <div className="clearfix mt30">
                    {exports.map(e => this.getLineForExport(e))}
                </div>

                <a href="" className="button small red" onClick={(e) => {
                    e.preventDefault();
                    this.setState({addAirbnbExportModalOpen: true})
                }}>
                    <span>Export to New Listingr</span>
                </a>

                <a href="" className="button small red" onClick={(e) => {
                    e.preventDefault();
                    this.setState({addAirbnbExportExistingModalOpen: true})
                }}>
                    <span>Export to Existing Listing</span>
                </a>

                <ExportToNewListingModal
                    propertyId={this.props.propertyId}
                    isOpen={this.state.addAirbnbExportModalOpen}
                    onClose={() => {
                        this.setState({addAirbnbExportModalOpen: false}, this.load)
                    }}
                />

                <ExportToExistingListingModal
                    propertyId={this.props.propertyId}
                    isOpen={this.state.addAirbnbExportExistingModalOpen}
                    onClose={() => {
                        this.setState({addAirbnbExportExistingModalOpen: false}, this.load)
                    }}
                />
            </div>
        )
    }
}


function Tooltip(i18n, code) {
    return (
        <span className="info top left">
            <i className="fa fa-question-circle"/>
                <span>
                 {i18n[code]}
                </span>
        </span>
    );
}

ChannelManagerAirbnb.propTypes = propTypes;

const mapStateToProps = state => ({
    i18n: state.languages.i18n
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ChannelManagerAirbnb);



// WEBPACK FOOTER //
// ./src/components/CreatingProperty/airbnbCm/ChannelManagerAirbnb.js